import { WarningDialog } from '@strata/react-dialog';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';

import { handleError } from 'services/ErrorManagement';
import { httpDelete } from 'services/Http';

export const DraftDeleteDialog = ({ payerId, draftId, isOpen, onSecondaryButtonClick }) => {
    const navigate = useNavigate();
    return (
        <WarningDialog
            dialogTitle="Delete Draft"
            isOpen={isOpen}
            primaryButtonLabel="Yes, Delete"
            onPrimaryButtonClick={async () => {
                try {
                    await httpDelete(`/clinicalpolicy/admin/${payerId}/drafts/${draftId}`);
                    navigate(`/policy-list/${payerId}`);
                } catch (err) {
                    handleError(`An error occurred deleting draft.`, err);
                }
            }}
            secondaryButtonLabel="No, Cancel"
            onSecondaryButtonClick={onSecondaryButtonClick}
            dialogContent={
                <div className="padding__bottom--large">
                    Are you sure you want to delete this draft?
                </div>
            }
        />
    );
};

DraftDeleteDialog.propTypes = {
    payerId: PropTypes.string.isRequired,
    draftId: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onSecondaryButtonClick: PropTypes.func.isRequired,
};
